/**
 * A caption's own alignment, as a utility class so it wins over its section's
 * (blockFlow.css); unset captions follow the section.
 */
export const captionAlignClass = (align: "left" | "center" | "right" | undefined) =>
  align ? { left: "text-left", center: "text-center", right: "text-right" }[align] : "";
